import React, { useEffect, useMemo, useState } from "react"
import { TimePicker as TPicker } from '@material-ui/lab';
import { TextField } from "@material-ui/core";
import moment from "moment";


const dateToTime = (vDate) => {
  const result = vDate && moment(vDate).format("HH:mm"); 
  return result;
}

export const TimePickerOqt = ({name, details = false, caption = "Fecha", formik, variant = "outlined", placeholder, onChange, minDate, invalidDateMessage, minDateMessage, maxDateMessage}) => {

  const formikValue = formik.values[name];

  const [value, setValue] = useState(!!formikValue ? moment("2024-01-01T" + formikValue) : null);

  useEffect(()=>{
      formik.setFieldValue(name, dateToTime(value));
  }, [value]);


  return (
    <div style={{ padding: 8 }}>

      <TPicker
        disabled={details}
        label={variant == "outlined" && caption}
        value={value}
        onChange={(value)=>{ 
          setValue(value)
        }}
        renderInput={(params) => <TextField  {...params} fullWidth  helperText=""  variant={variant} />}
      />
    </div>
  )
}

